import { makeStyles } from '@rbx/ui';

const useMarkdownAccordionStyles = makeStyles()((theme) => ({
  accordion: {
    '&:before': {
      display: 'none',
      height: 0,
    },
    '&.Mui-expanded': {
      marginTop: 0,
    },
    display: 'block',
    marginBottom: theme.spacing(2),
  },
}));

export default useMarkdownAccordionStyles;
